import { prepareFirstImageAsset } from '../../assetsHelper';
import { baseTransformer } from '../base';

export const listviewCardTransformer = (props) => {
    const asset = prepareFirstImageAsset(props.assets, props.isTouch, props.title);

    return {
        ...baseTransformer(props),
        asset,
    };
};
